import { render, staticRenderFns } from "./uploadImg.vue?vue&type=template&id=580f6718&scoped=true&"
import script from "./uploadImg.vue?vue&type=script&lang=ts&"
export * from "./uploadImg.vue?vue&type=script&lang=ts&"
import style0 from "./uploadImg.vue?vue&type=style&index=0&id=580f6718&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580f6718",
  null
  
)

export default component.exports